import type { Subscription } from "../../schemas/subscriptionSchema";
import { subscriptionSchema, subscriptionSchemaModal } from "../../schemas/subscriptionSchema";
import { buildColumnsFromSchema, buildModalFieldsFromSchema } from "../../schemas/schemaHelpers";
import type { SubscriptionQueryParams } from "../../api/subscriptions.service";

// Use the server-side sort field type from the generated OpenAPI spec
export type SortField = NonNullable<SubscriptionQueryParams["sortField"]>;

// Fields to show in table
const TABLE_FIELDS: Array<keyof Subscription> = [
  "companyName",
  "package",
  "siteStructureId",
  "site",
  "language",
  "startDate",
  "endDate",
  "status",
];

// Fields to show in modal overview tab
const MODAL_OVERVIEW_FIELDS: Array<keyof Subscription> = [
  "id",
  "companyName",
  "firmId",
  "package",
  "packageId",
  "billingTaxonomyTermId",
  "siteStructureId",
  "site",
  "language",
  "startDate",
  "endDate",
  "status",
  "correlationId",
  "createdAt",
  "updatedAt",
];

// Fields to show in modal metadata tab
const MODAL_METADATA_FIELDS: (keyof Subscription)[] = ["metadata"];

export const COLUMN_CONFIGS = buildColumnsFromSchema<Subscription>(
  subscriptionSchema,
  TABLE_FIELDS,
);
export const MODAL_OVERVIEW_FIELD_CONFIGS = buildModalFieldsFromSchema<Subscription>(
  subscriptionSchemaModal,
  MODAL_OVERVIEW_FIELDS,
);
export const MODAL_METADATA_FIELD_CONFIGS = buildModalFieldsFromSchema<Subscription>(
  subscriptionSchemaModal,
  MODAL_METADATA_FIELDS,
);

export const FILTER_OPTIONS = {
  status: [
    { value: "all", label: "All Status" },
    { value: "pending", label: "Pending" },
    { value: "complete", label: "Complete" },
    { value: "cancelled", label: "Cancelled" },
  ],
};

export const FILTER_CONFIGS = [{ key: "status", label: "Status", options: FILTER_OPTIONS.status }];
